import React, {useState, useRef, useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import Swal from "sweetalert2"
import styled from 'styled-components'

const StyledDiv = styled.div`
  width: 100%;
`

const Paypal = ({total = 0, description, destination, onSuccess = null}) => {
    const [error, setError] = useState(null)
    const paypalRef = useRef()
    const [purchaseComplete, setPurchaseComplete] = useState(false)
    const history = useHistory()

    useEffect(() => {
        window.paypal.Buttons({
            createOrder: (data, actions) => {
                return actions.order.create({
                    intent: 'CAPTURE',
                    purchase_units: [
                        {
                            description: description,
                            amount: {
                                currency_code: 'EUR',
                                value: total
                            }
                        }
                    ]
                })
            },
            onApprove: async (data, actions) => {
                const order = await actions.order.capture()
                setPurchaseComplete(true)
                console.log(order)
            },
            onError: (err) => {
                setError(err)
                console.log(err)
            }
        }).render(paypalRef.current)
    })

    if (purchaseComplete) {
        Swal.fire(
            'Merci !',
            'Votre paiement a bien été reçu !',
            'success'
        ).then(() => {
            if(onSuccess !== null) onSuccess()
            history.push(destination)
        })
    }

    if (error) {
        <h2>Une erreur est survenue, veuillez réessayer</h2>
    }
    return <StyledDiv ref={paypalRef}/>
}

export default Paypal
